import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const NoTransactionWrapperStyle = ({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: `${theme.palette.background.grey.light}`,
  borderRadius: 16,
  padding: 16,
  [theme.breakpoints.up('md')]: {
    padding: 24
  }
});

export const NoTransactionWrapper = styled(Stack)(NoTransactionWrapperStyle);
